export const namespaced = true;

export const state = {
  mobile_no: "",
  show_register_form: false,
  stepperValue: 1,

  // offer_list_details: {
  //   is_offers_list_loading: false,
  //   is_eligible: true,
  //   is_loan_exists: true, // not being used
  //   is_loan_amount_available: false,
  //   is_offers_available: false,
  // },
  // offer_list_details: null,
  offer_list_details: {
    is_loading: true,
    is_offer_available: false,
    is_eligible: true,
    is_logged_in: false,
  },
  eligibility_form: {},
  eligibility_form_one: {},
  eligibility_form_two: {},

  // Unified "Apply" onboarding popup (mobile login -> OTP -> EC1). Opened from any
  // product's Apply button when the user is not logged in. `product`/`loanTypeId`
  // carry the chosen product (no product-select screen). `ec1InDialog` is true for
  // Personal-Loan-family products that collect EC1 inside the dialog; false products
  // route to their own `registerRoute` after auth.
  apply_dialog: {
    open: false,
    product: null,
    loanTypeId: 1,
    ec1InDialog: true,
    offersRoute: "personal-loan-eligible-offers",
    registerRoute: null,
  },
};

export const mutations = {
  SET_MOBILE_NUMBER(state, payload) {
    state.mobile_no = payload;
  },
  SET_OFFER_LIST_DETAILS(
    state,
    { is_loading, is_offer_available, is_eligible, is_logged_in }
  ) {
    state.offer_list_details.is_loading = is_loading;
    state.offer_list_details.is_offer_available = is_offer_available;
    state.offer_list_details.is_eligible = is_eligible;
    state.offer_list_details.is_logged_in = is_logged_in;
  },
  SET_ELIGIBILITY_FORM(state, payload) {
    state.eligibility_form = payload;
  },
  SET_ELIGIBILITY_FORM_ONE(state, payload) {
    state.eligibility_form_one = payload;
  },
  SET_ELIGIBILITY_FORM_TWO(state, payload) {
    state.eligibility_form_two = payload;
  },
  SET_SHOW_REGISTER_FORM(state, payload) {
    state.show_register_form = payload;
  },
  SET_STEPPER(state, value) {
    state.stepperValue = value
  },
  SET_APPLY_DIALOG(state, payload) {
    state.apply_dialog = { ...state.apply_dialog, ...payload };
  },
};

export const actions = {
  setMobileNumber({ commit }, payload) {
    commit("SET_MOBILE_NUMBER", payload);
  },
  setOfferListDetails({ commit }, payload) {
    commit("SET_OFFER_LIST_DETAILS", payload);
  },
  setEligibilityForm({ commit }, payload) {
    commit("SET_ELIGIBILITY_FORM", payload);
  },
  setEligibilityFormOne({ commit }, payload) {
    commit("SET_ELIGIBILITY_FORM_ONE", payload);
  },
  setEligibilityFormTwo({ commit }, payload) {
    commit("SET_ELIGIBILITY_FORM_TWO", payload);
  },
  setShowRegisterForm({ commit }, payload) {
    commit("SET_SHOW_REGISTER_FORM", payload);
  },
  setStepper({ commit }, value) {
    commit('SET_STEPPER', value)
  },
  // Open the unified Apply popup. Defaults keep the Personal-Loan behaviour so a
  // bare `openApplyDialog()` still works; products override product/loanTypeId etc.
  openApplyDialog({ commit }, payload = {}) {
    commit("SET_APPLY_DIALOG", {
      open: true,
      product: payload.product || null,
      loanTypeId: payload.loanTypeId || 1,
      ec1InDialog: payload.ec1InDialog !== false,
      offersRoute: payload.offersRoute || "personal-loan-eligible-offers",
      registerRoute: payload.registerRoute || null,
    });
  },
  closeApplyDialog({ commit }) {
    commit("SET_APPLY_DIALOG", { open: false });
  },
};
export const getters = {
  getMobileNumber: (state) => {
    return state.mobile_no;
  },
  getShowRegisterForm: (state) => {
    return state.show_register_form;
  },
  getOfferListDetails: (state) => {
    return state.offer_list_details;
  },
  getEligibilityForm: (state) => {
    return state.eligibility_form;
  },
  getEligibilityFormOne: (state) => {
    return state.eligibility_form_one;
  },
  getEligibilityFormTwo: (state) => {
    return state.eligibility_form_two;
  },
  getStepperValue: (state) => {
    return state.stepperValue;
  },
  getApplyDialog: (state) => {
    return state.apply_dialog;
  },
};
